// utils/labSetup.js
export function setupLabID() {
  const callingURL = window.location.hostname;
  let isTest = 0;

  const rawCustomURL = process.env.REACT_APP_CUSTOMURL;
  let customURLArray = {};

  try {
    customURLArray = JSON.parse(rawCustomURL);
  } catch (e) {
    console.error("❌ Failed to parse REACT_APP_CUSTOMURL:", rawCustomURL, e);
  }

  const getCustomValue = (domain) => {
    const domainKey = domain?.toUpperCase();
    return customURLArray?.[domainKey] || null;
  };

  let LabID = getCustomValue(callingURL.toUpperCase());
  if (!LabID) {
    const URLArray = callingURL.split(".");
    let LabIDl = URLArray[0].split("-");
    LabID = LabIDl[0].toUpperCase();
    isTest = LabIDl[1] === "test" ? 1 : 0;
  }

  if (process.env.NODE_ENV !== "production") {
    LabID = process.env.REACT_APP_LABID;
    isTest = 1;
  }

  sessionStorage.setItem("LABID", LabID);
  sessionStorage.setItem("ISTEST", isTest);

  return LabID;
}
